import React from "react";

export const StatCardSkeleton = () => (
  <div className="bg-white rounded-2xl px-4 py-4 shadow-md border border-gray-100 animate-pulse">
    <div className="flex items-start gap-3">
      <div className="w-[42px] h-[42px] rounded-xl bg-gray-200 shrink-0" />
      <div className="flex-1 min-w-0 space-y-2 pt-0.5">
        <div className="h-3.5 w-20 bg-gray-200 rounded" />
        <div className="h-6 w-12 bg-gray-200 rounded" />
        <div className="h-3 w-24 bg-gray-100 rounded" />
      </div>
    </div>
    <div className="h-8 w-full bg-gray-100 rounded mt-3" />
  </div>
);

export const SurveyRowSkeleton = () => (
  <tr className="border-b border-gray-50 last:border-0 animate-pulse">
    <td className="px-4 py-3">
      <div className="flex items-start gap-3">
        <div className="bg-gray-200 rounded-lg shrink-0 w-[34px] h-[34px]" />
        <div className="space-y-2 flex-1">
          <div className="h-3.5 w-40 bg-gray-200 rounded" />
          <div className="h-3 w-52 bg-gray-100 rounded" />
        </div>
      </div>
    </td>
    <td className="px-4 py-3">
      <div className="h-5 w-16 bg-gray-200 rounded-full" />
    </td>
    <td className="px-4 py-3 text-center">
      <div className="h-3.5 w-6 bg-gray-200 rounded mx-auto" />
    </td>
    <td className="px-4 py-3 text-center">
      <div className="h-3.5 w-6 bg-gray-200 rounded mx-auto" />
    </td>
    <td className="px-4 py-3">
      <div className="h-3.5 w-20 bg-gray-200 rounded mb-1.5" />
      <div className="h-3 w-14 bg-gray-100 rounded" />
    </td>
    <td className="px-4 py-3">
      <div className="h-3.5 w-20 bg-gray-200 rounded mb-1.5" />
      <div className="h-3 w-14 bg-gray-100 rounded" />
    </td>
    <td className="px-4 py-3">
      <div className="flex items-center justify-end gap-2">
        {[0, 1, 2].map((i) => (
          <div key={i} className="w-8 h-8 rounded-lg bg-gray-200" />
        ))}
      </div>
    </td>
  </tr>
);